import {register} from '../../../assets/js/modules/eventMap';

const stripe = async () => {
    try {
        const Stripe = await import('./vendor/stripe/main.js');

        await Stripe.init();
    } catch (error) {
        console.error('Kinde: Error loading Stripe vendor dependency: ', error);
    }
};

const loadDependency = () => {
    register('loadDependency', {
        stripe
    });
};

export {loadDependency};
